function encodeUid(value) {
  return encodeURIComponent(value || '');
}

function safeSliceValue(slice = 0) {
  return Math.max(0, Number.isFinite(Number(slice)) ? Math.floor(Number(slice)) : 0);
}

function buildSeriesRenderPath(studyInstanceUID, seriesInstanceUID, slice = 0, suffixBuilder = null) {
  const study = encodeUid(studyInstanceUID);
  const series = encodeUid(seriesInstanceUID);
  const safeSlice = safeSliceValue(slice);
  const suffix = suffixBuilder ? suffixBuilder(safeSlice) : `?slice=${safeSlice}&ww=0&wc=0`;
  return `/render/study/${study}/series/${series}${suffix}`;
}

export function getSeriesRenderUrl(studyInstanceUID, seriesInstanceUID, slice = 0) {
  return buildSeriesRenderPath(studyInstanceUID, seriesInstanceUID, slice);
}

export function getSeriesThumbnailUrl(studyInstanceUID, seriesInstanceUID, slice = 0, size = 160) {
  const safeSize = Math.max(64, Math.min(384, Number.isFinite(Number(size)) ? Math.floor(Number(size)) : 160));
  return buildSeriesRenderPath(studyInstanceUID, seriesInstanceUID, slice, (safeSlice) => `/thumbnail?slice=${safeSlice}&size=${safeSize}&ww=0&wc=0`);
}


export const KAIROS_SERIES_INGEST_PROGRESS = 'KAIROS_SERIES_INGEST_PROGRESS';

const normStatus = value => String(value ?? '').trim().toLowerCase();

const numberOrNull = value => {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) && n >= 0 ? n : null;
};

export function getSeriesIngestProgress(series = {}) {
  const status = normStatus(
    series.ingestStatus ?? series.ingest_status
      ?? series.processingStatus ?? series.processing_status
      ?? series.receiveStatus ?? series.receive_status
      ?? series.importStatus ?? series.import_status
  );
  const pending = numberOrNull(
    series.ingestPending ?? series.ingest_pending
      ?? series.processingPending ?? series.processing_pending
      ?? series.instancesPending ?? series.instances_pending
      ?? series.imagesPending ?? series.images_pending
  );
  const running = numberOrNull(
    series.ingestRunning ?? series.ingest_running
      ?? series.processingRunning ?? series.processing_running
      ?? series.instancesRunning ?? series.instances_running
      ?? series.imagesRunning ?? series.images_running
  );
  const expected = numberOrNull(
    series.expectedInstances ?? series.expected_instances
      ?? series.expectedInstanceCount ?? series.expected_instance_count
      ?? series.instancesExpected ?? series.instances_expected
      ?? series.imagesExpected ?? series.images_expected
  );
  const current = numberOrNull(
    series.receivedInstances ?? series.received_instances
      ?? series.numInstances ?? series.num_instances ?? series.instanceCount
  );
  if ((pending ?? 0) > 0 || (running ?? 0) > 0) {
    const count = (pending ?? 0) + (running ?? 0);
    return { active: true, label: count > 0 ? `${count} incoming` : 'incoming', detail: 'More images are still being ingested or processed for this series.' };
  }
  if (expected !== null && current !== null && expected > current) {
    return { active: true, label: `+${expected - current} expected`, detail: `${current}/${expected} images received; more images are expected.` };
  }
  if (['receiving', 'ingesting', 'processing', 'pending', 'queued', 'running', 'in_progress', 'importing'].includes(status)) {
    return { active: true, label: status === 'in_progress' ? 'processing' : status, detail: 'This series is still being received or processed.' };
  }
  return { active: false, label: '', detail: '' };
}
